import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Clientele from "@/pages/Clientele";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Experience from "@/pages/Experience";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPostPage from "@/pages/BlogPost";
import BlogNew from "@/pages/BlogNew";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/clientele" element={<Clientele />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
                <Route path="/experience" element={<Experience />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/new" element={<BlogNew />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
            <Toaster position="bottom-center" theme="dark" richColors />
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
